import React, { Component } from 'react'
import './AnnouncesBar.css';

export default class AnnouncesBar extends Component {
  render() {
    return (
      <div className='AnnouncesBar'>
        🔒 Compra segura | Pagas al recibir
      </div>
    )
  }
}
